const DEFAULT_DURATION = 3000;

export class Notification {

  static lastID = 0;

  public message: string;
  public duration: number;
  public id: number;
  public type: string;

  constructor(message: string, type: string, duration?: number) {
    this.id = Notification.lastID++;
    this.message = message;
    this.duration = duration || DEFAULT_DURATION;
    this.type = type;
  }
}

export function bindNotificationsModule(Vue) {
  Object.defineProperty(
    Vue.prototype, "$notify", {
      get: function () {
        return {
          success: function (message: string, duration?: number) {
            this.$store.dispatch("notifySuccess", {message, duration});
          }.bind(this),
          error: function (message: string, duration?: number) {
            this.$store.dispatch("notifyError", {message, duration});
          }.bind(this),
          custom: function (notification: Notification) {
            this.$store.dispatch("notify", notification);
          }.bind(this)
        }
      }
    });
}

export default {
  state: {
    notifications: []
  },

  getters: {
    notifications: state => state.notifications
  },

  mutations: {
    addNotification(state, notification: Notification) {
      state.notifications.push(notification);
    },
    removeNotification(state, notificationId) {
      state.notifications = state.notifications.filter(n => n.id !== notificationId);
    }
  },

  actions: {

    notify({commit}, notification: Notification) {
      commit("addNotification", notification);
    },

    notifySuccess({commit, getters}, {message, duration}:  {message: string, duration?: number}) {
      commit("addNotification", new Notification(message, "success", duration));
    },

    notifyError({commit, getters},  {message, duration}:  {message: string, duration?: number}) {
      commit("addNotification", new Notification(message, "error", duration));
    },

    closeNotification({commit}, notificationIdx) {
      commit("removeNotification", notificationIdx);
    }
  }
};